// Accordion JS

// const accordionHeaders = document.querySelectorAll(".Faq-Title");

// accordionHeaders.forEach((header) => {
// 	header.addEventListener("click", () => {
// 		header.classList.toggle("active");
// 		const body = header.nextElementSibling;
// 		if (body.classList.contains("active")) {
// 			body.classList.remove("active");
// 			body.style.maxHeight = null;
// 		} else {
// 			body.classList.add("active");
// 			body.style.maxHeight = body.scrollHeight + "px";
// 		}
// 	});
// });

$(".bundleForm").on("submit", function (e) {
  var data = $(this).serialize();
  e.preventDefault();
  addItemToCart(data);

  console.log("asdasdasd");

  $(".site-header__cart")
    .click(function (e) {
      e.preventDefault();
      this.click();
    })
    .click();
});

function addItemToCart(data) {
  jQuery.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: data,
    dataType: "json",
    success: function () {
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:refresh", {
          bubbles: true, //this code is for prestige theme, is to refresh the cart
        })
      );
    },
  });
}

let section_counter = document.querySelector("#section_counter");
let counters = document.querySelectorAll(".tick");
let counterObserver = new IntersectionObserver(
  (entries, observer) => {
    let [entry] = entries;
    if (!entry.isIntersecting) return;
    //console.log(entries);
    let speed = 200;
    counters.forEach((counter, index) => {
      function UpdateCounter() {
        const target = counter.dataset.value;
        const targetNumber = parseInt(target);
        const initialNumber = +counter.innerText;

        const incPerCount = targetNumber / speed;
        if (initialNumber < targetNumber) {
          counter.innerText = Math.ceil(initialNumber + incPerCount);
          setTimeout(UpdateCounter, 40);
        } else {
          counter.innerText = targetNumber;
        }
      }
      UpdateCounter();
      if (counter.parentElement.style.animation) {
        counter.parentElement.style.animation = "";
      } else {
        counter.parentElement.style.animation = `${
          index / counters.length + 0.5
        }s`;
      }
    });
    observer.unobserve(section_counter);
  },
  {
    root: null,
    threshold: 0.4,
  }
);

section_counter && counterObserver.observe(section_counter);

// $('.bundle-preview--next .button').click(function(){
// 	var ID = $(this).attr("data-var_id");
// 	addItemToCart( ID, 1);
// 	$('#cart-icon-bubble').trigger( "click" );
// 	});
// 	function addItemToCart(variant_id, qty) {
// 	data = {
// 		"id": variant_id,
// 		"quantity": qty
// 	}
// 	jQuery.ajax({
// 		type: 'POST',
// 		url: '/cart/add.json',
// 		data: data,
// 		dataType: 'json',
// 		success: function() {
// 		document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
// 			bubbles: true
// 		}));
// 		}

// 	});

// }

// Single Product Collapsible Content

$(".collapsible_wrap h4").click(function () {
  const height = $(this)
    .siblings(".collaps_content_wrap")
    .children()
    .outerHeight();
  $(this).toggleClass("active");
  const newHeight = height + 20;
  if ($(this).siblings().height() == newHeight) {
    $(this).siblings().height(0);
    $(this).siblings().removeClass("active");
  } else {
    $(this).siblings().height(newHeight);
    $(this).siblings().addClass("active");
  }
  $(this).parent().siblings().children(".collaps_content_wrap").height(0);
  $(this)
    .parent()
    .siblings()
    .children(".collaps_content_wrap")
    .removeClass("active");
  $(this)
    .parent()
    .siblings()
    .children(".collapsible_wrap h4")
    .removeClass("active");
});

// Single product page add to cart button

// $('.single-page-product-price, .product .product-form__item--quantity--fixed-btn, .product__info-container .product-form__cart-submit').wrapAll('<div class="fixed-btn-wrapper"></div>');

// Insert div

$(document).ready(function () {
  var infoWrapper = $(".product .product__info-wrapper");

  var collapsibleDiv = $(".product .product_collapsible");

  infoWrapper.append(collapsibleDiv);
});

const headers = document.querySelectorAll(".Faq-Title");

headers.forEach((header) => {
  header.addEventListener("click", () => {
    const content = header.nextElementSibling;
    const accordion = header.parentNode;

    // Close all accordion items except the clicked one
    const activeItems = accordion.querySelectorAll(".active");
    activeItems.forEach((item) => {
      if (item !== content) {
        item.classList.remove("active");
        item.style.maxHeight = null;
      }
    });

    // Toggle the clicked accordion item
    content.classList.toggle("active");
    if (content.classList.contains("active")) {
      content.style.maxHeight = content.scrollHeight + "px";
      header.classList.add("active");
    } else {
      content.style.maxHeight = null;
      header.classList.remove("active");
    }
  });
});

// slider

const slides = Array.from(document.querySelectorAll(".carousel_slide"));
const slider = document.querySelectorAll(".carouseljs");
const buttons = document.querySelectorAll(".buttons div");
const dotsEl = document.querySelector(".dots");

let timeoutId;

function getNextPrev() {
  const activeSlide = document.querySelector(".carousel_slide-active");
  const activeIndex = slides.indexOf(activeSlide);

  //console.log(activeIndex);

  let next, prev;

  //console.log(next, prev);

  if (activeIndex === slides.length - 1) {
    next = slides[0];
  } else {
    next = slides[activeIndex + 1];
  }

  if (activeIndex === 0) {
    prev = slides[slides.length - 1];
  } else {
    prev = slides[activeIndex - 1];
  }
  return [next, prev];
}

function getPosition() {
  const activeSlide = document.querySelector(".carousel_slide-active");
  const activeIndex = slides.indexOf(activeSlide);
  const [next, prev] = getNextPrev();
  slides.forEach((slide, index) => {
    if (index === activeIndex) {
      slide.style.transform = "translateX(0)";
    } else if (slide === prev) {
      slide.style.transform = "translateX(-100%)";
    } else if (slide === next) {
      slide.style.transform = "translateX(100%)";
    } else {
      slide.style.transform = "translateX(100%)";
    }
    slide.addEventListener("transitionend", () => {
      slide.classList.remove("top");
    });
  });
}
buttons.forEach((button) => {
  button.addEventListener("click", () => {
    if (button.classList.contains("next")) getNextSlide();
    else if (button.classList.contains("prev")) getPrevSlide();
  });
});

function getNextSlide() {
  clearInterval(timeoutId);

  const currentSlide = document.querySelector(".carousel_slide-active");
  const [next, prev] = getNextPrev();

  if (currentSlide && currentSlide.classList.contains("top")) {
    return;
  }

  if (currentSlide) {
    currentSlide.classList.add("top");
    next.classList.add("top");
    currentSlide.style.transform = "translate(-100%)";
    currentSlide.classList.remove("carousel_slide-active");

    next.style.transform = "translateX(0)";
    next.classList.add("carousel_slide-active");
    getPosition();
    getActiveDot();
    autoLoop();
  }
}

function getPrevSlide() {
  clearInterval(timeoutId);
  const currentSlide = document.querySelector(".carousel_slide-active");
  const [next, prev] = getNextPrev();
  currentSlide.classList.add("top");
  prev.classList.add("top");
  currentSlide.style.transform = "translate(100%)";
  currentSlide.classList.remove("carousel_slide-active");
  prev.style.transform = "translateX(0)";
  prev.classList.add("carousel_slide-active");
  getPosition();
  getActiveDot();
  autoLoop();
}
getPosition();

// dots
slides.forEach((slide) => {
  const dot = document.createElement("div");
  dot.classList.add("dot");
  dotsEl.appendChild(dot);
});
function getActiveDot() {
  const allDots = document.querySelectorAll(".dots .dot");

  if (allDots.length) {
    allDots.forEach((dot) => {
      dot.classList.remove("carousel_slide-active");
    });
    const activeSlide = document.querySelector(".carousel_slide-active");
    const activeIndex = slides.indexOf(activeSlide);
    if (allDots[activeIndex])
      allDots[activeIndex].classList.add("carousel_slide-active");
  }
}
function functionalDots() {
  const allDots = document.querySelectorAll(".dots .dot");
  allDots.forEach((dot, index) => {
    dot.addEventListener("click", () => {
      getDotSlide(index);
    });
  });
}
function getDotSlide(index) {
  clearTimeout(timeoutId);
  slides.forEach((slide) => {
    slide.classList.remove("carousel_slide-active");
  });
  const currentSlide = slides[index];

  currentSlide.classList.add("carousel_slide-active");
  getPosition();
  getActiveDot();
  autoLoop();
}

function autoLoop() {
  timeoutId = setTimeout(() => {
    getNextSlide();
  }, 2000);
}

getActiveDot();
functionalDots();
autoLoop();

$(".close-x").on("click", function (e) {
  $(this).parent().fadeOut();

  $(".cleanse-list").animate({ height: "180px" });
  e.preventDefault();
});
